import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgTick(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 -4 14 24" {...props}>
      <path
        d="M6.603 7.317L5 8.959 9.627 14 19 3.642 17.397 2l-7.77 8.586z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Tick')(SvgTick);
